import RpcClass from "../../../../../server/RpcClass.js";

import yaml from "js-yaml"

import RpcNotFoundException from "../../../../../server/com/silkplm/engine/rpc/exceptions/RpcNotFoundException.js";

let locale;
if(typeof window !== "undefined") {
    locale = window?.navigator?.userLanguage || window?.navigator?.language || Intl.DateTimeFormat().resolvedOptions().locale;
} else {
    locale= RpcClass.locale = Intl.DateTimeFormat().resolvedOptions().locale;
}

const FULL_CLASS = 'com.silkplm.model.plm.Suppliers';

import LocalDate from "../../../../../server/LocalDate.js";
import LocalDateTime from "../../../../../server/LocalDateTime.js";
import LocalTime from "../../../../../server/LocalTime.js";



class Suppliers extends RpcClass{

    /**
     *  @class Suppliers
     *  @alias module:src/server/com/silkplm/model/plm/Suppliers.Suppliers
     *  
     * */
    constructor(){
        super();

        /** @type {string}  */
        this.EID = null;
        /** @type {boolean}  */
        this.__archived = null;
        /** @type {number}  */
        this.__familyId = null;
        /** @type {boolean}  */
        this.__hidden = null;
        /** @type {number}  */
        this.__parent = null;
        /** @type {Date}  */
        this.__versionDate = null;
        /** @type {Object.<string, *>}  */
        this._translations = null;
        /** @type {boolean}  */
        this.active = null;
        /** @type {string}  */
        this.addressLine1 = null;
        /** @type {string}  */
        this.addressLine2 = null;
        /** @type {module:src/server/com/silkplm/model/files/FileInRepository.FileInRepository[]}  */
        this.attachments = null;
        /** @type {boolean}  */
        this.automaticSendInquiry = null;
        /** @type {module:src/server/com/silkplm/model/plm/BankDetails.BankDetails[]}  */
        this.bankAccounts = null;
        /** @type {string}  */
        this.baseName = null;
        /** @type {string}  */
        this.city = null;
        /** @type {string}  */
        this.companyFullName = null;
        /** @type {string}  */
        this.companyShortName = null;
        /** @type {string}  */
        this.contractorAttributes = null;
        /** @type {string}  */
        this.country = null;
        /** @type {BigDecimal}  */
        this.creditLimit = null;
        /** @type {string}  */
        this.currencyId = null;
        /** @type {string}  */
        this.currentSelectedRegion = null;
        /** @type {string}  */
        this.deliveryPort = null;
        /** @type {string}  */
        this.descriptionOfTheContractor = null;
        /** @type {string}  */
        this.district = null;
        /** @type {string}  */
        this.externalIDs = null;
        /** @type {string}  */
        this.id = null;
        /** @type {string}  */
        this.incoterms = null;
        /** @type {string}  */
        this.invitationLink = null;
        /** @type {boolean}  */
        this.invitationSent = null;
        /** @type {boolean}  */
        this.isAccountCreated = null;
        /** @type {string}  */
        this.notes = null;
        /** @type {number}  */
        this.numberOfDays = null;
        /** @type {number}  */
        this.operationalTimeDays = null;
        /** @type {string}  */
        this.operationalTimeDescription = null;
        /** @type {string}  */
        this.otherEmailAddresses = null;
        /** @type {string}  */
        this.otherPhones = null;
        /** @type {boolean}  */
        this.preInspection = null;
        /** @type {string}  */
        this.primaryEmail = null;
        /** @type {string}  */
        this.primaryPhone = null;
        /** @type {module:src/server/com/silkplm/engine/entities/tracking/RecordMetadata.RecordMetadata}  */
        this.recordMetadata = null;
        /** @type {string}  */
        this.regon = null;
        /** @type {boolean}  */
        this.removedAndBlockedRoleSupplier = null;
        /** @type {boolean}  */
        this.roleForwarder = null;
        /** @type {boolean}  */
        this.roleRecipient = null;
        /** @type {boolean}  */
        this.roleSupplier = null;
        /** @type {string}  */
        this.shipmentPort = null;
        /** @type {string}  */
        this.silkOrganizationId = null;
        /** @type {string}  */
        this.state = null;
        /** @type {string}  */
        this.street = null;
        /** @type {string}  */
        this.supplierCode = null;
        /** @type {string}  */
        this.supplierType = null;
        /** @type {string}  */
        this.suppliersLanguage = null;
        /** @type {string}  */
        this.taxID = null;
        /** @type {string}  */
        this.termsOfPayment = null;
        /** @type {string}  */
        this.uuid = null;
        /** @type {number}  */
        this.version = null;
        /** @type {string}  */
        this.www = null;
        /** @type {string}  */
        this.zipCode = null;

        if(window["SessionManager"]?.isLoggedIn()){
            const formConfig = window['FormsLoader']?.detectFormConfig(FULL_CLASS);
            for(const f of formConfig.fields){
                if(f.formDisabled){
                    continue;
                }
                if( f.defaultValue !== null) {
                    this[f.fieldName] = yaml.load(f.defaultValue);
                }
             }
        }
    }




    /**
     * Get list of detail List Of Contractor Attribute
     * @returns {Promise<ListOfContractorAttribute[]>}
     */

    async listListOfContractorAttribute(){
    return Rpc.Forms.listDetails(
        FULL_CLASS,
        this.id,
        "com.silkplm.model.plm.ListOfContractorAttribute",
        "supplierId");
    }
    /**
     * Get list of detail Representative
     * @returns {Promise<Representative[]>}
     */

    async listRepresentative(){
    return Rpc.Forms.listDetails(
        FULL_CLASS,
        this.id,
        "com.silkplm.model.plm.Representative",
        "supplierId");
    }

    /** @type {string}  */
    get countryISOCode(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['countryISOCode'] : null, this.__metadata__['countryISOCode']?.remoteType);
    }
    set countryISOCode(val){
    }
    // fk: false

    /** @type {string}  */
    get computedExternalIDs(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['computedExternalIDs'] : null, this.__metadata__['computedExternalIDs']?.remoteType);
    }
    set computedExternalIDs(val){
    }


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Suppliers.Suppliers}
     */
    withEID(val){
        this.EID = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/Suppliers.Suppliers}
     */
    with__archived(val){
        this.__archived = val;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/model/plm/Suppliers.Suppliers}
     */
    with__familyId(val){
        this.__familyId = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/Suppliers.Suppliers}
     */
    with__hidden(val){
        this.__hidden = val;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/model/plm/Suppliers.Suppliers}
     */
    with__parent(val){
        this.__parent = val;
        return this;
    };


    /**
     * @param val {Date}
     * @returns {module:src/server/com/silkplm/model/plm/Suppliers.Suppliers}
     */
    with__versionDate(val){
        let rawValue = val;
        let v = val;
        v = new Date(rawValue)
        this.__versionDate = v;
        return this;
    };


    /**
     * @param val {Object.<string, *>}
     * @returns {module:src/server/com/silkplm/model/plm/Suppliers.Suppliers}
     */
    with_translations(val){
        this._translations = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/Suppliers.Suppliers}
     */
    withActive(val){
        this.active = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Suppliers.Suppliers}
     */
    withAddressLine1(val){
        this.addressLine1 = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Suppliers.Suppliers}
     */
    withAddressLine2(val){
        this.addressLine2 = val;
        return this;
    };


    /**
     * @param val {module:src/server/com/silkplm/model/files/FileInRepository.FileInRepository[]}
     * @returns {module:src/server/com/silkplm/model/plm/Suppliers.Suppliers}
     */
    withAttachments(val){
        this.attachments = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/Suppliers.Suppliers}
     */
    withAutomaticSendInquiry(val){
        this.automaticSendInquiry = val;
        return this;
    };


    /**
     * @param val {module:src/server/com/silkplm/model/plm/BankDetails.BankDetails[]}
     * @returns {module:src/server/com/silkplm/model/plm/Suppliers.Suppliers}
     */
    withBankAccounts(val){
        this.bankAccounts = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Suppliers.Suppliers}
     */
    withBaseName(val){
        this.baseName = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Suppliers.Suppliers}
     */
    withCity(val){
        this.city = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Suppliers.Suppliers}
     */
    withCompanyFullName(val){
        this.companyFullName = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Suppliers.Suppliers}
     */
    withCompanyShortName(val){
        this.companyShortName = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Suppliers.Suppliers}
     */
    withContractorAttributes(val){
        this.contractorAttributes = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Suppliers.Suppliers}
     */
    withCountry(val){
        this.country = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getCountryLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Country', 'country', allowRemote); //  true 
    }

    /** @returns {String} */
        getCountryStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Country', 'country'); //  true 
    }

        /** @returns {Promise<Country>} */
    getCountryEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Country', 'country', allowRemote); //  true 
    }

    /**
     * @param val {BigDecimal}
     * @returns {module:src/server/com/silkplm/model/plm/Suppliers.Suppliers}
     */
    withCreditLimit(val){
        let rawValue = val;
        let v = val;
        v = new BigDecimal(rawValue)
        this.creditLimit = v;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Suppliers.Suppliers}
     */
    withCurrencyId(val){
        this.currencyId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getCurrencyIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Currency', 'currencyId', allowRemote); //  true 
    }

    /** @returns {String} */
        getCurrencyIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Currency', 'currencyId'); //  true 
    }

        /** @returns {Promise<Currency>} */
    getCurrencyIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Currency', 'currencyId', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Suppliers.Suppliers}
     */
    withCurrentSelectedRegion(val){
        this.currentSelectedRegion = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Suppliers.Suppliers}
     */
    withDeliveryPort(val){
        this.deliveryPort = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getDeliveryPortLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.DeliveryPort', 'deliveryPort', allowRemote); //  true 
    }

    /** @returns {String} */
        getDeliveryPortStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.DeliveryPort', 'deliveryPort'); //  true 
    }

        /** @returns {Promise<DeliveryPort>} */
    getDeliveryPortEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.DeliveryPort', 'deliveryPort', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Suppliers.Suppliers}
     */
    withDescriptionOfTheContractor(val){
        this.descriptionOfTheContractor = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Suppliers.Suppliers}
     */
    withDistrict(val){
        this.district = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Suppliers.Suppliers}
     */
    withExternalIDs(val){
        this.externalIDs = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Suppliers.Suppliers}
     */
    withId(val){
        this.id = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Suppliers.Suppliers}
     */
    withIncoterms(val){
        this.incoterms = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getIncotermsLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Incoterms', 'incoterms', allowRemote); //  true 
    }

    /** @returns {String} */
        getIncotermsStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Incoterms', 'incoterms'); //  true 
    }

        /** @returns {Promise<Incoterms>} */
    getIncotermsEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Incoterms', 'incoterms', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Suppliers.Suppliers}
     */
    withInvitationLink(val){
        this.invitationLink = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/Suppliers.Suppliers}
     */
    withInvitationSent(val){
        this.invitationSent = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/Suppliers.Suppliers}
     */
    withIsAccountCreated(val){
        this.isAccountCreated = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Suppliers.Suppliers}
     */
    withNotes(val){
        this.notes = val;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/model/plm/Suppliers.Suppliers}
     */
    withNumberOfDays(val){
        this.numberOfDays = val;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/model/plm/Suppliers.Suppliers}
     */
    withOperationalTimeDays(val){
        this.operationalTimeDays = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Suppliers.Suppliers}
     */
    withOperationalTimeDescription(val){
        this.operationalTimeDescription = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Suppliers.Suppliers}
     */
    withOtherEmailAddresses(val){
        this.otherEmailAddresses = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Suppliers.Suppliers}
     */
    withOtherPhones(val){
        this.otherPhones = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/Suppliers.Suppliers}
     */
    withPreInspection(val){
        this.preInspection = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Suppliers.Suppliers}
     */
    withPrimaryEmail(val){
        this.primaryEmail = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Suppliers.Suppliers}
     */
    withPrimaryPhone(val){
        this.primaryPhone = val;
        return this;
    };


    /**
     * @param val {module:src/server/com/silkplm/engine/entities/tracking/RecordMetadata.RecordMetadata}
     * @returns {module:src/server/com/silkplm/model/plm/Suppliers.Suppliers}
     */
    withRecordMetadata(val){
        this.recordMetadata = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Suppliers.Suppliers}
     */
    withRegon(val){
        this.regon = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/Suppliers.Suppliers}
     */
    withRemovedAndBlockedRoleSupplier(val){
        this.removedAndBlockedRoleSupplier = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/Suppliers.Suppliers}
     */
    withRoleForwarder(val){
        this.roleForwarder = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/Suppliers.Suppliers}
     */
    withRoleRecipient(val){
        this.roleRecipient = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/Suppliers.Suppliers}
     */
    withRoleSupplier(val){
        this.roleSupplier = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Suppliers.Suppliers}
     */
    withShipmentPort(val){
        this.shipmentPort = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getShipmentPortLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Port', 'shipmentPort', allowRemote); //  true 
    }

    /** @returns {String} */
        getShipmentPortStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Port', 'shipmentPort'); //  true 
    }

        /** @returns {Promise<Port>} */
    getShipmentPortEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Port', 'shipmentPort', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Suppliers.Suppliers}
     */
    withSilkOrganizationId(val){
        this.silkOrganizationId = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Suppliers.Suppliers}
     */
    withState(val){
        this.state = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Suppliers.Suppliers}
     */
    withStreet(val){
        this.street = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Suppliers.Suppliers}
     */
    withSupplierCode(val){
        this.supplierCode = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Suppliers.Suppliers}
     */
    withSupplierType(val){
        this.supplierType = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getSupplierTypeLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.SupplierType', 'supplierType', allowRemote); //  true 
    }

    /** @returns {String} */
        getSupplierTypeStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.SupplierType', 'supplierType'); //  true 
    }

        /** @returns {Promise<SupplierType>} */
    getSupplierTypeEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.SupplierType', 'supplierType', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Suppliers.Suppliers}
     */
    withSuppliersLanguage(val){
        this.suppliersLanguage = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Suppliers.Suppliers}
     */
    withTaxID(val){
        this.taxID = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Suppliers.Suppliers}
     */
    withTermsOfPayment(val){
        this.termsOfPayment = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getTermsOfPaymentLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.TermsOfPayment', 'termsOfPayment', allowRemote); //  true 
    }

    /** @returns {String} */
        getTermsOfPaymentStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.TermsOfPayment', 'termsOfPayment'); //  true 
    }

        /** @returns {Promise<TermsOfPayment>} */
    getTermsOfPaymentEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.TermsOfPayment', 'termsOfPayment', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Suppliers.Suppliers}
     */
    withUuid(val){
        this.uuid = val;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/model/plm/Suppliers.Suppliers}
     */
    withVersion(val){
        this.version = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Suppliers.Suppliers}
     */
    withWww(val){
        this.www = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Suppliers.Suppliers}
     */
    withZipCode(val){
        this.zipCode = val;
        return this;
    };




    /**
    * @param {string[]?} fields
    * @returns {Promise<Suppliers>}
    */
    async save(fields){
        return this.__save(FULL_CLASS, fields);
    }

    async load(id=null){
        if(id == null){
            id = this.id;
        }
        let newVersion = await loadSuppliers(id);
        for(const k in newVersion){
            this[k] = newVersion[k];
        }
    }
    /**
     * @return {Promise}
     */
    async delete(){
        return Rpc.Forms.deleteEntity(FULL_CLASS, this.id);
    }
    /**
     * @param {*|string} replacementIdOrInst
     * @return {Promise}
     */
    async deleteWithReplacement(replacementIdOrInst){
        if(replacementIdOrInst.hasOwnProperty('id')){
            replacementIdOrInst = replacementIdOrInst.id;
        }
        return Rpc.Forms.deleteEntityWithReplacement(FULL_CLASS, this.id, replacementIdOrInst);
    }
    /**
     * CAN_DELETE | SUGGEST_REPLACEMENT | FORCE_REPLACEMENT | DELETE_RESTRICTED | DELETE_NOT_PERMITTED
     * @return {Promise<String>>}
     */
    async canDelete(){
        return Rpc.Forms.canDeleteEntity(FULL_CLASS, this.id);
    }

    /**
     * @param fieldName
     * @returns {Promise<FieldValidationResult>}
     */
    async validateField(fieldName){
        return Rpc.Forms.validateField(FULL_CLASS, fieldName, this[fieldName], this.id);
    }

    /**
     * @returns {Promise<InputValidationResult>}
     */
    async checkConstraints(){
        return Rpc.Forms.checkConstraints(FULL_CLASS, this);
    }
    /** @returns {Promise<String>}*/
    async getFkFieldLabel(fiendName, allowRemote=false) {
        if(fiendName === 'country'){
            return this.getCountryLabel(allowRemote);
        }
        if(fiendName === 'currencyId'){
            return this.getCurrencyIdLabel(allowRemote);
        }
        if(fiendName === 'deliveryPort'){
            return this.getDeliveryPortLabel(allowRemote);
        }
        if(fiendName === 'incoterms'){
            return this.getIncotermsLabel(allowRemote);
        }
        if(fiendName === 'shipmentPort'){
            return this.getShipmentPortLabel(allowRemote);
        }
        if(fiendName === 'supplierType'){
            return this.getSupplierTypeLabel(allowRemote);
        }
        if(fiendName === 'termsOfPayment'){
            return this.getTermsOfPaymentLabel(allowRemote);
        }

        return '';
    }

    /** @returns {Promise<*>}*/
    async getFkFieldEntity(fiendName, allowRemote=false) {
        if(fiendName === 'country'){
            return this.getCountryEntity(allowRemote);
        }
        if(fiendName === 'currencyId'){
            return this.getCurrencyIdEntity(allowRemote);
        }
        if(fiendName === 'deliveryPort'){
            return this.getDeliveryPortEntity(allowRemote);
        }
        if(fiendName === 'incoterms'){
            return this.getIncotermsEntity(allowRemote);
        }
        if(fiendName === 'shipmentPort'){
            return this.getShipmentPortEntity(allowRemote);
        }
        if(fiendName === 'supplierType'){
            return this.getSupplierTypeEntity(allowRemote);
        }
        if(fiendName === 'termsOfPayment'){
            return this.getTermsOfPaymentEntity(allowRemote);
        }
        return null;
    }


    /**
     * @param {string} externalSystemName
     * @returns {Promise<string>}
     */
    async externalId(externalSystemName){
        //clazzName, silkId, extSystem
        return Rpc.Integrations.silkIdToExternalId(FULL_CLASS, this.id, externalSystemName);
    }

    /**
     * @param {string} externalSystemName
     * @param {string} externalId
     * @returns {Promise<>}
     */
    async loadByExternalId(externalSystemName, externalId){
    //clazzName, silkId, extSystem
        let res = await Rpc.Integrations.externalIdToSilk(FULL_CLASS, externalId, externalSystemName);
        if(res.recordStatus !== "EXISTS"){
            throw new RpcNotFoundException({originalMessage:`Record status: ${res.recordStatus}`});
        }
        await this.load(res.silkId);
    }

    /**
     * @param {string} externalSystemName
     * @param {string} externalId
     * @returns {Promise<>}
     */
    async bindExternalId(externalSystemName, externalId){
      //clazzName, extId, extSystem, silkId
      return Rpc.Integrations.setMapping(FULL_CLASS, externalId, externalSystemName, this.id);
   }

    /**
     * @param {string} externalSystemName
     * @param {string} externalId
     * @returns {Promise<>}
     */
    async removeExternalId(externalSystemName, externalId){
        //clazzName, silkId, extSystem
        return Rpc.Integrations.clearMapping(FULL_CLASS, externalId, externalSystemName, this.id);
    }

    /**
     * @param {string} externalSystemName
     * @param {string} keyName
     * @returns {Promise<string>}
     */
    async readBoundValue(externalSystemName, keyName){
      let res = await Rpc.Integrations.readObjectData(FULL_CLASS, this.id, externalSystemName, keyName);
      return JSON.parse(res);
    }

    /**
     * @param {string} externalSystemName
     * @param {string} keyName
     * @param {Object} val
     * @returns {Promise<>}
     */
    async bindValue(externalSystemName, keyName, val){
      return Rpc.Integrations.storeObjectData(FULL_CLASS, externalSystemName, this.id, keyName, val);
    }

    /** @returns {string} */
    getRemoteClass(){
        return FULL_CLASS;
    }
}

/**
 * @param {string} id
 * @param {boolean?} loadFkObjects
 * @returns {Promise<Suppliers>}
 */
async function loadSuppliers(id, loadFkObjects){
    if(loadFkObjects){
        return Rpc.Forms.getExtendedEntity(FULL_CLASS, id);
    }
    return Rpc.Forms.getEntity(FULL_CLASS, id);
}

/**
 * @returns {Promise<Suppliers[]>}
 */
async function listSuppliers(){
    return Rpc.Forms.listEntities(FULL_CLASS);
}

/**
 * @param {string} id
 * @returns {Promise<string>}
 */
async function labelSuppliers(id){
    return Rpc.Forms.getEntityLabel(FULL_CLASS, id);
}
// STATICS --------------------------------------

/**
 * @param {string} id
 * @param {boolean?} loadDetails
 * @returns {Promise<Suppliers>}
 */
Suppliers.load = async function(id, loadDetails=false){
    if(loadDetails){
        return Rpc.Forms.getExtendedEntity(FULL_CLASS, id);
    }
    return Rpc.Forms.getEntity(FULL_CLASS, id);
}

/**
 * @returns {Promise<Suppliers[]>}
 */
Suppliers.list = async function(){
    return Rpc.Forms.listEntities(FULL_CLASS);
}

/**
 * @returns {Promise<Suppliers[]>}
 */
Suppliers.listExtended = async function(){
    return Rpc.Forms.listExtendedEntities(FULL_CLASS);
}

/**
 * @returns {Promise<Suppliers[]>}
 */
Suppliers.getRemoteClass = function(){
    return FULL_CLASS;
}

/**
 * @param {string} externalSystem
 * @param {string} extId
 * @param {boolean?} loadDetails
 * @returns {Promise<Suppliers>}
 */
Suppliers.loadByExternalId = async function(externalSystem, extId, loadDetails=false){

    let res = await Rpc.Integrations.externalIdToSilk(FULL_CLASS, extId, externalSystem);
    if(res.recordStatus !== "EXISTS"){
        throw new RpcNotFoundException({originalMessage:`Record status: ${res.recordStatus}`});
    }
    return Suppliers.load(res.silkId, loadDetails);
}


// INTEGRATIONS --------------------------------

/**
 * @param {string} externalSystemName
 * @param {string} silkId
 * @returns {Promise<IdMapping>}
 */
Suppliers.bindingFromSilkId = async function(externalSystemName, silkId){
    //clazzName, silkId, extSystem
    return Rpc.Integrations.silkIdToExternalId(FULL_CLASS, silkId, externalSystemName);
}

/**
 * @param {string} externalSystemName
 * @param {string} externalId
 * @returns {Promise<IdMapping>}
 */
Suppliers.bindingFromExternalId = async function(externalSystemName, externalId){
    //clazzName, silkId, extSystem
    return  Rpc.Integrations.externalIdToSilk(FULL_CLASS, externalId, externalSystemName);
}

/**
 * @param {string} externalSystemName
 * @param {string} externalId
 * @param {string} silkId
 * @returns {Promise<>}
 */
Suppliers.bindExternalId = async function(externalSystemName, externalId, silkId){
    //clazzName, extId, extSystem, silkId
    return Rpc.Integrations.setMapping(FULL_CLASS, externalId, externalSystemName, silkId);
}

/**
 * @param {string} externalSystemName
 * @param {string} externalId
 * @returns {Promise<>}
 */
Suppliers.removeExternalId = async function(externalSystemName, externalId, silkId){
    //clazzName, silkId, extSystem
    return Rpc.Integrations.clearMapping(FULL_CLASS, externalId, externalSystemName, silkId);
}

/**
 * @param {IdMapping} binding
 * @returns {Promise<>}
 */
Suppliers.removeExternalBinding = async function(binding){
    //clazzName, silkId, extSystem
    return Rpc.Integrations.clearMapping(FULL_CLASS, binding.externalId, binding.externalSystem, binding.silkId);
}



let metadata = {};
metadata['EID'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['__archived'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['__familyId'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['__hidden'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['__parent'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['__versionDate'] = {'remoteType' : 'java.time.Instant', 'jsType' : 'Date', 'mapped' : 'true'};
metadata['_translations'] = {'remoteType' : 'Object.<string, *>', 'jsType' : 'Object.<string, *>', 'mapped' : 'false'};
metadata['active'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['addressLine1'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['addressLine2'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['attachments'] = {'remoteType' : 'module:src/server/com/silkplm/model/files/FileInRepository.FileInRepository[]', 'jsType' : 'module:src/server/com/silkplm/model/files/FileInRepository.FileInRepository[]', 'mapped' : 'false'};
metadata['automaticSendInquiry'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['bankAccounts'] = {'remoteType' : 'module:src/server/com/silkplm/model/plm/BankDetails.BankDetails[]', 'jsType' : 'module:src/server/com/silkplm/model/plm/BankDetails.BankDetails[]', 'mapped' : 'false'};
metadata['baseName'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['city'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['companyFullName'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['companyShortName'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['contractorAttributes'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['country'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['creditLimit'] = {'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['currencyId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['currentSelectedRegion'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['deliveryPort'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['descriptionOfTheContractor'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['district'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['externalIDs'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['id'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['incoterms'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['invitationLink'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['invitationSent'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['isAccountCreated'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['notes'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['numberOfDays'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['operationalTimeDays'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['operationalTimeDescription'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['otherEmailAddresses'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['otherPhones'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['preInspection'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['primaryEmail'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['primaryPhone'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['recordMetadata'] = {'remoteType' : 'module:src/server/com/silkplm/engine/entities/tracking/RecordMetadata.RecordMetadata', 'jsType' : 'module:src/server/com/silkplm/engine/entities/tracking/RecordMetadata.RecordMetadata', 'mapped' : 'false'};
metadata['regon'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['removedAndBlockedRoleSupplier'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['roleForwarder'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['roleRecipient'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['roleSupplier'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['shipmentPort'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['silkOrganizationId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['state'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['street'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['supplierCode'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['supplierType'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['suppliersLanguage'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['taxID'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['termsOfPayment'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['uuid'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['version'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['www'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['zipCode'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['computedExternalIDs'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['countryISOCode'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};

metadata.__type__ = 'com.silkplm.model.plm.Suppliers';
metadata.__type_short__ = 'Suppliers';
Suppliers.prototype.__metadata__ = metadata;

Suppliers.prototype.__cls__ = FULL_CLASS;

/** @module src/server/com/silkplm/model/plm/Suppliers */
export default Suppliers

export { Suppliers , loadSuppliers, listSuppliers, labelSuppliers }
